import React from "react";

const SvgInline = ({ src, className, onClick }) => {
  return (
    <i
      className={className}
      dangerouslySetInnerHTML={{ __html: src }}
      onClick={onClick}
    />
  );
};

export default SvgInline;
